import { render, staticRenderFns } from "./yoyo-actions.vue?vue&type=template&id=0a8953af&scoped=true&"
import script from "./yoyo-actions.vue?vue&type=script&lang=js&"
export * from "./yoyo-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8953af",
  null
  
)

export default component.exports